import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPriorityPlus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#priority_plus_svg__a)"
        strokeWidth={8}
        d="m78.489 18.633-2.829-2.829 2.829 2.829 1.183-1.183c4.6-4.6 12.057-4.6 16.656 0l1.183 1.183 2.828-2.829-2.828 2.829a19.78 19.78 0 0 0 13.985 5.792h.301c6.505 0 11.778 5.273 11.778 11.778v.301a19.78 19.78 0 0 0 5.792 13.985l1.184 1.183 2.828-2.828-2.828 2.828c4.599 4.6 4.599 12.057 0 16.656l2.828 2.828-2.828-2.828-1.184 1.183a19.78 19.78 0 0 0-5.792 13.985v.301c0 6.505-5.273 11.778-11.778 11.778h-.301a19.78 19.78 0 0 0-13.985 5.792l-1.183 1.184 2.828 2.828-2.828-2.828c-4.6 4.599-12.056 4.599-16.656 0l-1.183-1.184a19.78 19.78 0 0 0-13.985-5.792h-.301c-6.505 0-11.778-5.273-11.778-11.778v-.301a19.78 19.78 0 0 0-5.792-13.985l-2.805 2.804 2.805-2.804-1.184-1.183c-4.599-4.6-4.599-12.056 0-16.656l1.184-1.183-2.829-2.828 2.829 2.828a19.78 19.78 0 0 0 5.792-13.985v-.301c0-6.505 5.273-11.778 11.778-11.778h.301a19.78 19.78 0 0 0 13.985-5.792Z"
      />
      <path
        fill="#D2F3DC"
        d="m68 80 14.966-40h9.958L108 80H97.16l-2.53-8.336H81.15L78.619 80zm15.406-16h9.023l-4.457-14.77h-.11z"
      />
      <path
        fill="#fff"
        d="M29.975 2.975a.975.975 0 1 0-1.95 0c0 4.056-.895 6.754-2.595 8.455-1.7 1.7-4.399 2.595-8.455 2.595a.975.975 0 1 0 0 1.95c4.056 0 6.754.895 8.455 2.595 1.7 1.7 2.595 4.399 2.595 8.455a.975.975 0 1 0 1.95 0c0-4.056.895-6.754 2.595-8.455 1.7-1.7 4.399-2.595 8.455-2.595a.975.975 0 1 0 0-1.95c-4.056 0-6.754-.895-8.455-2.595-1.7-1.7-2.595-4.399-2.595-8.455"
      />
      <defs>
        <linearGradient
          id="priority_plus_svg__a"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPriorityPlus);
export default ForwardRef;
